module.exports = __webpack_public_path__ + "static/thpcbearmain-036a3beec45920f618f6a57b06c50582.jpeg";